import en from "@collectie/i18n/en";
import zhHant from "@collectie/i18n/zh-Hant";
import de from "@collectie/i18n/de";

export type Locale = "en" | "zh-Hant" | "de";
type CopyTree = Record<string, unknown>;

const dictionaries: Record<Locale, CopyTree> = {
  en: en as CopyTree,
  "zh-Hant": zhHant as CopyTree,
  de: de as CopyTree,
};

export function t(
  locale: Locale,
  key: string,
  values: Record<string, string | number> = {},
): string {
  let current: unknown = dictionaries[locale];
  for (const part of key.split(".")) {
    if (!current || typeof current !== "object") return key;
    current = (current as CopyTree)[part];
  }
  if (typeof current !== "string") return key;
  return Object.entries(values).reduce(
    (result, [name, value]) => result.replaceAll(`{${name}}`, String(value)),
    current,
  );
}
